// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"e3c56781","2444":"e3c56781"}[chunkId] + ".chunk.css";
};